export default __webpack_public_path__ + "static/media/include_17@2x.beae6ecb.jpg";